// アプリで 1 つだけ持つ進捗の画面側の包み。src/main.ts が mount の前に load する。
import { clock, progress } from '../../services';
import { createProgressView, type ProgressView } from './progress-view.svelte';

export const appProgress: ProgressView = createProgressView(progress, clock);
